import WMSLayer from '@arcgis/core/layers/WMSLayer';
import { GISServiceTypes } from '../gisServicesTypes';
import { ensureLoadedLayerArray, LayerLoader } from './LayerLoader';
import { resolveAdminOpacity } from './defaultLayerLoader';

export const wmsLayerLoader: LayerLoader = {
  shouldUseLoader(service) {
    return service.service_type == GISServiceTypes.wms;
  },
  async load(service) {
    const layerNames = service?.attributes?.sublayers || [];
    const adminOpacity = resolveAdminOpacity(service);

    const layer = new WMSLayer({
      id: service.gisLayerID,
      url: service.gis_service_url,
      visible: false,
      sublayers: layerNames.map(name => ({ name })),
      ...(adminOpacity !== undefined ? { opacity: adminOpacity } : {}),
    });

    await layer.load();
    return ensureLoadedLayerArray(layer);
  },
};
